<template>
  <gauge v-if="ready" :name="name" :min="min" :max="max" :value="value" :infoMessage="infoMessage" />
</template>

<script>
import Gauge from '@/components/Crops/Gauge'

export default {
  name: 'gauge-card',
  props: ['data','type','infoMessage'],
  components: { Gauge },
  data() {
    return {
      name: '',
      min: 0,
      max: 0,
      value: 0,
      ready: false
    }
  },
  watch: {
    data() {
      this.generateGauge();
    }
  },
  mounted() {
    this.generateGauge();
  },
  methods: {

    generateGauge() {
      this.ready = false;
      if (this.type == 'price') {
        this.name = "Margen de venta \r\nde precio";
        this.min = this.data['mdv_precio_minimo'];
        this.max = this.data['mdv_precio_maximo'];
        this.value = this.data['mdv_precio'];
      }
      if (this.type == 'render') {
        this.name = "Margen de venta \r\nde rinde";
        this.min = this.data['mdv_rinde_minimo'];
        this.max = this.data['mdv_rinde_maximo'];
        this.value = this.data['mdv_rinde'];
      }
      if (this.type == 'rinde_equilibrio') {
        this.name = "Rinde de Equilibrio";
        this.min = 0;
        this.max = 100;
        this.value = this.data['prob_perdida'];
      }
      if (this.type == 'rinde_esperado') {
        this.name = "Rinde Esperado";
        this.min = 0;
        this.max = 100;
        this.value = this.data['prob_perdida'];
      }
      this.$nextTick(function () {
        this.ready = true;
      })

    }
  }
}

</script>
